import React from "react";
import BillingDetailDTO from "features/billings/dtos/BillingDetailDTO";
import { useQuery } from "data/hooks/useQuery";
import { Billings_BillingDetails, Billings_Get } from "data/endpoints";
import InvoiceLineCalculationDTO from "features/invoices/dtos/InvoiceLineCalculationDTO";
import { getRouteParams } from "features/shared/helpers/routeParams";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import BillingInfoCard from 'features/billings/components/BillingInfoCard';
import BillingAreaList from 'features/billings/components/BillingAreaList';
import { useTranslation } from "react-i18next";
import { getQueryParams } from "features/shared/helpers/queryParams";

interface Props {
  billingId: string;
  isFueling?: boolean;
}

const BillingDetailSection = ({ billingId, isFueling }: Props) => {
  // translations
  const { t: tLabels, i18n } = useTranslation(["billings\\billings"]);
  
  // helpers
  const getFuelingParams = () =>
    isFueling ? getQueryParams("IsFueling", `${isFueling}`) : undefined;

  // side-effects
  // fetch data
  const { data: billing, loadStatus: billingStatus } =
    useQuery<InvoiceLineCalculationDTO>(
      {
        url: Billings_Get,
        routeParams: getRouteParams("billingId", billingId),
        params: getFuelingParams()
      },
      {},
      [billingId]
    );
  const { data: billingDetails, loadStatus: billingDetailsStatus } = useQuery<
    BillingDetailDTO[]
  >(
    {
      url: Billings_BillingDetails,
      routeParams: getRouteParams("billingId", billingId),
      params: getFuelingParams()
    },
    [],
    [billingId, i18n.language]
  );

  // render
  return (
    <NoContentWrapper
      data={billing}
      loadStatus={billingStatus}
      noContentAsAlert
    >
      <BillingInfoCard 
        billing={billing} 
        isFueling={isFueling}
      />
      <NoContentWrapper
        data={billingDetails}
        loadStatus={billingDetailsStatus}
        noContentInfo={tLabels("billingDetailSection.noBillingDetailsFound")}
        noContentAsAlert
      >
        <BillingAreaList 
          billingDetails={billingDetails} 
          periodFrom={billing.periodFrom!}
          periodTo={billing.periodTo!}
        />
      </NoContentWrapper>
    </NoContentWrapper>
  );
};

export default BillingDetailSection;